import { SelectQueryBuilder } from 'typeorm'

import { Font } from '@things-factory/font-base'
import { Attachment } from '@things-factory/attachment-base'
import { getRepository, Domain } from '@things-factory/shell'

export const fonts = async (domain?: Domain) => {
  const qb: SelectQueryBuilder<Font> = await getRepository(Font).createQueryBuilder('FONT')

  var fonts = domain
    ? await qb
        .select('FONT.name', 'name')
        .distinct(true)
        .addSelect('FONT.provider', 'provider')
        .addSelect('FONT.id', 'id')
        .addSelect('FONT.uri', 'uri')
        .where({ domain: { id: domain.id }, active: true })
        .getRawMany()
    : await qb
        .select('FONT.name', 'name')
        .distinct(true)
        .addSelect('FONT.provider', 'provider')
        .addSelect('FONT.id', 'id')
        .addSelect('FONT.uri', 'uri')
        .where({ active: true })
        .getRawMany()

  var googleFonts = fonts.filter(({ provider }) => provider === 'google')
  var customFonts = fonts.filter(({ provider }) => provider === 'custom')

  var customFontCSS: string = ''

  for (const font of customFonts) {
    var files: Attachment[] = domain
      ? await getRepository(Attachment).findBy({
          domain: { id: domain.id },
          refBy: font.id
        })
      : await getRepository(Attachment).findBy({
          refBy: font.id
        })

    if (files && files.length > 0) {
      customFontCSS += files
        .map(file => {
          const { name: filename, fullpath } = file
          const bold = filename.toUpperCase().indexOf('BOLD') !== -1

          return `@font-face {
            font-family: '${font.name}';
            src: local('${font.name}'), url(${fullpath});
            font-weight: ${bold ? 'bold' : 'normal'};
          }
          `
        })
        .join('\n')
    } else {
      customFontCSS += `@font-face {
          font-family: '${font.name}';
          src: local('${font.name}')${font.uri ? `, url(${font.uri})` : ''};
        }
        `
    }
  }

  return googleFonts.length > 0 || customFonts.length > 0
    ? [
        {
          ...(googleFonts.length > 0 && {
            google: {
              families: googleFonts.map(({ name }) => name)
            }
          }),
          ...(customFonts.length > 0 && {
            custom: {
              families: customFonts.map(({ name }) => name)
            }
          })
        },
        customFonts.length > 0 ? customFontCSS : null
      ]
    : []
}
